import EmptySearchIcon from '@/assets/images/EmptySearchIcon.png';
import { DefaultOutlinedButton } from '@/components/buttons';
import { FormsActions } from '@/store/forms';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
export const EmptySearchResult = () => {
    const dispatch = useDispatch();
    return (React.createElement(Stack, { maxWidth: "500px", alignItems: "center", justifyContent: "center", gap: 2, mt: 8 },
        React.createElement("img", { src: EmptySearchIcon, alt: "empty-icon", width: 200 }),
        React.createElement(Typography, { fontSize: "1rem", fontWeight: 500, textAlign: "center", color: "secondary.light", px: { xs: 0, sm: '20px' } }, "Sorry, we are unable to find any grants for you. Please adjust your organization description or try again later."),
        React.createElement(DefaultOutlinedButton, { title: "Try again", onClick: () => dispatch(FormsActions.setValue({ id: 'steps', step: 1 })) })));
};
